import React from 'react';
import {Outlet} from "react-router-dom";

import css from './PublicLayout.module.css';


const PublicLayout = () => {
    return (
        <section className={css.wrap}>
            <Outlet/>
        </section>
    );
};

export {PublicLayout};